import '../grouped_elements/applied_grouped_elements_view.js.coffee'
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.AppliedLabelsView extends Monitoring.Views.SocialContents.Filters.AppliedGroupedElementsView
  name: 'labels'
  alias: 'Groups'

  getDescription: (value) ->
    return I18n.t('customer.dashboard.filters.creation.groups.all_groups') if value == 'allLabels'
    return I18n.t('customer.dashboard.filters.creation.groups.no_groups') if value == 'noLabels'
    return value

  _primaryName: () ->
    'primary_labels'

  _secondaryName: () ->
    'secondary_labels'

  _excludedName: () ->
    'excluded_labels'

  removeFilter: (value, list) ->
    @searchQuery.removePrimaryLabel(value)   if list == @withPrefix('primary_elements')
    @searchQuery.removeSecondaryLabel(value) if list == @withPrefix('secondary_elements')
    @searchQuery.removeExcludedLabel(value)  if list == @withPrefix('excluded_elements')
